import useCurrentProfile from './useCurrentProfile';
import useCurrentUser from './useCurrentUser';

export const useIsSender = sender => {
  const currentUser = useCurrentUser();
  const currentProfile = useCurrentProfile();

  if (sender.type === 'Profile') {
    return currentProfile?.id === sender.id;
  } else {
    return currentUser?.id === sender.id;
  }
};
